import  * as AppliedValues from "@/components/explorer/visualizations/AppliedValues.js";
import {ChartTypeEnum, getchartNameFromApiName} from  "@/components/explorer/visualizations/ChartTypeEnum.js"
import { event } from 'vue-gtag'

const version = __APP_VERSION__

class ChartSettings {
    constructor(sortCol, type, mapProps, tooltipLevels) {
 		this.type = type        
 		this.currentPage = 0;
		this.pageSize = parseInt(import.meta.env.VITE_API_MAP_PAGE_SIZE);
		this.totalItems = 0;
		this.totalPages = 1;
		this.sortColumn = sortCol;
		this.sortDirection = sortCol.columnName == 'Year'?'DESC':'ASC';
		this.request = null;
		this.mapProps = mapProps;
		//this.mapLevel = null;
		this.tooltipLevels = tooltipLevels
    }   
}

async function defineMapProps(indicatorObj, chartSettings, mapLevel, selectAllGeoValues) {

	let indicatorName = indicatorObj.indicatorName
	let allDims = getAllDims(indicatorObj)
	let geoDim = allDims.find(x => {
		return x.columnName == mapLevel.columnName
	})	

	let childDim = null
	if(geoDim.childColumnName)
		childDim = allDims.find(x => x.columnName == geoDim.childColumnName && x.geoLabelFlag)

	if(selectAllGeoValues) {
		geoDim.appliedValues.forEach(x => x.selected = true) 
		if(childDim) {
			childDim.appliedValues.forEach(x => x.selected = true) 
		}
	} else {
		if(!geoDim.appliedValues.find(x => x.selected)) {
			chartSettings.totalItems = 0
			chartSettings.totalPages = 0
			return {"chartSettings": chartSettings,  "dataResults": null}
		}
	}
	chartSettings.seriesDim = childDim||geoDim

	
	//override series dim which may not be a geo dim with the properties geo dim
	//chartSettings.seriesDim = geoDim	
	try {
		let requests = buildRequests(indicatorName, chartSettings, allDims, geoDim, mapLevel)
		//console.log('Map Request', requests)
		if(import.meta.env.VITE_APP_DEBUG)
			console.log('map request', requests)	

		let infoResult = await fetchData(requests.request, 'tableinfo')
		if(import.meta.env.VITE_APP_DEBUG)
			console.log('Map infoResult', infoResult);

		chartSettings.totalItems = infoResult.count;
		chartSettings.totalPages = Math.ceil(chartSettings.totalItems / chartSettings.pageSize)

		//Get subtotals for tooltips if indicator supports subtotals to display
		if(geoDim.subtotalValues && geoDim.subtotalValues.length > 0) {
			let columnSubTotals = []
			let totals = await fetchData(requests.requestTotals, 'tabledata')

			for (const [key, grpValue] of Object.entries(totals[chartSettings.mapProps.levels[0].columnName])) {
				let t = {}
				t.tipGrp = grpValue
				if(chartSettings.mapProps.levels[0].groupColumnName) 
					t.tipLink = Object.entries(totals[chartSettings.mapProps.levels[0].groupColumnName])[key][1]
				else 
					t.tipLink = Object.entries(totals[chartSettings.mapProps.levels[0].columnName])[key][1]
				t.tipValue = Object.entries(totals[indicatorObj.valuesLabel])[key][1]
				columnSubTotals.push(t)				
			}

			//store totals to render in tooltip
			if(import.meta.env.VITE_APP_DEBUG)
				console.log('Map columnSubTotals', columnSubTotals);
			chartSettings.columnSubTotals = columnSubTotals;
		}

		//Use multiple pages with a specific page size to limit amount of data being retrieved in each API request
		let dataResults = null
		for(chartSettings.currentPage = 0; chartSettings.currentPage < chartSettings.totalPages; chartSettings.currentPage++) {
			if(chartSettings.currentPage == 0) {
				chartSettings.request = requests.request;
				//console.log('Map chartSettings', chartSettings)			
			}
			requests.request.page = chartSettings.currentPage
			let results = await fetchData(requests.request, 'tabledata')
			if(dataResults == null) {
				dataResults = results
			} else {
				for (const prop in results) {
					let cnt = Object.keys(dataResults[prop]).length
					for (const [key, value] of Object.entries(results[prop])) {
						dataResults[prop][cnt++] = value
					}					
				}
			}
		}
		return {"chartSettings": chartSettings,  "dataResults": dataResults}
	} catch (err) {
		console.log('Error in defineMapProps', err)
		throw err
	}
}

function buildRequests(indicatorName, chartSettings, allFilters, geoDim, mapLevel) {
	let request = {
		"datasetName": indicatorName,
		"columns": []
	}

	let requestTotals = {
		"datasetName": indicatorName,
		"columns": []
	}	

	request.page = chartSettings.currentPage
	request.pageSize = chartSettings.pageSize
	// let geoDim = null
	// geoDim = allFilters.find(x => {
	// 	return x.columnName == mapLevel.columnName
	// })
	//Build 2 requests when indicator has a geo field and a group field defined in map properties: 
	// 1) get sub totals for values defined in map properties. These results will be used in the map tool tips. 
	// 2) data request to retrieve data that excludes sub totals and is used for map values

	//1st request: Request for aggregate values used in tooltips only. If indicator doesn't support a group then tool will skip this request
	if(mapLevel.groupColumnName && mapLevel.groupColumnName != "") {
		//May not need to apply group filter, since API will work without this field
		const grpCat = {}
		const grp = allFilters.find(x => x.columnName == mapLevel.groupColumnName)
		const grpTotals = []
		grp.appliedValues.forEach(s => {
			//include all group values except those that are flagged to be excluded
			// if(!mapLevel.excludes || !mapLevel.excludes.includes(s.name)) {
			// 	grpTotals.push(s.name)
			// } 
			setNonExcluded(mapLevel.excludes, grpTotals, s.name)				
		})
		grpCat.columnName = mapLevel.groupColumnName
		grpCat.filters = grpTotals
		requestTotals.columns.push(grpCat)

		const geoCat = {}
		geoCat.columnName = mapLevel.columnName
		geoCat.filters = geoDim.subtotalValues || []
		//geoCat.filters = JSON.parse(JSON.stringify(mapLevel.columnSubTotals))
		if(mapLevel.columnTotal && mapLevel.columnTotal != "")
			geoCat.filters.push(mapLevel.columnTotal)
		requestTotals.columns.push(geoCat)
	} 

	let nextLevel = null
	if(mapLevel.level == 0 && chartSettings.mapProps.levels.length > 1)
		nextLevel = chartSettings.mapProps.levels[1]

	//2nd request: request for all data except aggregate values
	for(let x = 0; x < allFilters.length; x++) {
		let col = allFilters[x]
		
		let cat = {}
		cat.columnName = col.columnName

		let selectedVals = []
		if(col.columnName == geoDim.columnName) {
			if(geoDim.subtotalValues == null || geoDim.subtotalValues.length == 0) {
				//col has geo data but no subtotals, add all values to request
				if(import.meta.env.VITE_APP_DEBUG)
					console.log('geo dim with NO subtotals', geoDim.columnName)
				col.appliedValues.forEach(s => {			
					if(s.selected) {
						//exclude values specified in props file from map request, i.e., Unassigned
						// if(!mapLevel.excludes || !mapLevel.excludes.includes(s.name)) {
						// 	selectedVals.push(s.name)
						// }
						setNonExcluded(mapLevel.excludes, selectedVals, s.name)							
					}
				})
			} else {
				//col has geo data and subtotals, add non total/subtotal vales to request
				if(import.meta.env.VITE_APP_DEBUG)
					console.log('geo dim with subtotals nestedCols', geoDim.columnName)
				//since col has subtotals should always be part of hierarchy
				if(col.nestedColumns){
					col.nestedColumns.forEach(s => {
						if(s.selected && s.appliedValues) {
							s.appliedValues.forEach(t => {
								//see if current value matches a value in properties sub totals or total value
								const matchesTotal = (geoDim.subtotalValues && geoDim.subtotalValues.includes(t.name))
									|| (mapLevel.columnTotal && t.name == mapLevel.columnTotal);
								if(t.selected && !matchesTotal) {
									// if(!mapLevel.excludes || !mapLevel.excludes.includes(t.name)) {
									// 	selectedVals.push(t.name)
									// }
									setNonExcluded(mapLevel.excludes, selectedVals, t.name)	
								
									// if(mapLevel.excludes && mapLevel.excludes.forEach(x => t.name.startsWith(x))) {
									// 	selectedVals.push(t.name)
									// }										
								}
							})
						}
					})
				}
			}
		} else if(nextLevel != null && col.columnName == nextLevel.columnName
			&& col.subtotalValues && col.subtotalValues.length > 0) {
			//col has geo data and subtotals, but is for a drilldown level. Add selected values that are also in subtotals
			if(import.meta.env.VITE_APP_DEBUG)	
				console.log('Non active geo dim with subtotals', geoDim.columnName)
			let subVals =  col.appliedValues.filter(x => x.selected && col.subtotalValues.includes(x.name))
			if(subVals)
				selectedVals = subVals.map(x => {return x.name})
			else
				selectedVals = []
		} else if(mapLevel.groupColumnName && col.columnName == mapLevel.groupColumnName) {
			//col is part of hierarchy but used for grouping child dim values. User does not select nor filter group dims.  Select all values
			//Select all values, user can filter on child dim values.
			if(import.meta.env.VITE_APP_DEBUG)	
				console.log('Grouping col', geoDim.columnName)			
			col.appliedValues.forEach(x => {
				//include all group values except those that are flagged to be excluded
				// if(!mapLevel.excludes || !mapLevel.excludes.includes(x.name)) {
				// 	selectedVals.push(x.name)
				// }	
				setNonExcluded(mapLevel.excludes, selectedVals, x.name)								
			})				
		} else {
			//col is not an indicator level but is a data filter, so only allow one value to be selected
			const defaultVals = col.defaultValues.filter(x => col.distinctValues.includes(x))
			const dataVals = col.appliedValues.filter(s => s.selected)
			const allVal = col.totalLabel
			const totalLabelFound = col.distinctValues.includes(allVal)					
			if(dataVals.length > 0) {
				if(col.columnName !== 'Year') {
					//set to first selected value
					selectedVals.push(dataVals[0].name)
					dataVals.forEach((x,i) => {	
						x.selected = i>0?false:true
					})
				} else {
					//set to last selected value
					selectedVals.push(dataVals[dataVals.length - 1].name)
					dataVals.forEach((x,i) => {	
						x.selected = i !== dataVals.length - 1 ? false:true
					})
				}
			} else if (defaultVals.length > 0) {
				//use default value is no vals selected
				const val = col.appliedValues.find(s => s.name = defaultVals[0] && s.selected)				
				selectedVals.push(val.name)
			} else if(totalLabelFound) {
				const val = col.appliedValues.find(s => s.name = allVal && s.selected)
				selectedVals.push(val.name)
			} else if(col.columnName === 'Year' ) {
				//unless the columnName = Year then use the last value
				selectedVals.push(col.appliedValues[col.appliedValues.length - 1].name)
			} else {
				//no selected value, no default, and no Totals defined, so select the first value as the default
				selectedVals.push(col.appliedValues.find(s => s.selected).name)
			}
		}
		cat.filters = selectedVals
		request.columns.push(cat)
		if((col.columnName !== geoDim.columnName) && (mapLevel.groupColumnName == null || col.columnName !== mapLevel.groupColumnName)) {
			requestTotals.columns.push(cat)
		}
	}
	let requests = {
		request: request,
		requestTotals: requestTotals
	}
	return requests;
}

function setNonExcluded(excludes, selectedVals, value) {
	let found
	if(excludes !== null && excludes.length > 0){
		found = excludes.findIndex(x => x != '' && value.startsWith(x))
		if(found == -1) {
			selectedVals.push(value)
		} 
	} else {
		selectedVals.push(value)
	}
	return
}


async function fetchData(request, apiMethod) {
	//console.log(indicatorName)
	const apiUrl = import.meta.env.VITE_API_URL;

	let reqFilters = '';
	request.columns.forEach((cat) => {
		reqFilters += cat.columnName + ': ' + cat.filters.join() + '|';
	})
	event('filter_dataset', { 'indicator' : request.datasetName, 'dimensions': null, 'filter' : reqFilters.slice(0,100).slice(0,-1) })

	let url = apiUrl + '/indicators/api/' + apiMethod
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-api-version': version
		},
			body: JSON.stringify(request)
		}
	)
	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	return await response.json()
}

function getAllDims(indicator) {
	let columns = indicator.columns.items.filter(col => {
		if(col.categoryLabelFlag)	
			return col;
	})
	return columns
}

function getMapSettings(indicator, type, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('getMapSettings')
		console.log('userInputStatus.geo',userInputStatus.geo)
	}
	AppliedValues.setupAppliedValues(indicator)
	//default geo field values to selected
	let geoCol = indicator.columns.items.find(col => col.geoLabelFlag)
	if(geoCol) {
		geoCol.appliedValues.forEach(val => {
			val.selected = true
		})
	}

	//default selected category to first valid category, select all values including totals
	let sortCol = indicator.columns.items.find(col => col.categoryLabelFlag)
	return new ChartSettings(sortCol, "map")
}

function updateMapSettings(settings, indicator, userInputStatus) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('updateMapSettings')
	}
	let firstCol = indicator.columns.items.find(col => col.categoryLabelFlag);

	settings.type = 'map'
	settings.currentPage = 0;
	settings.pageSize = parseInt(import.meta.env.VITE_API_MAP_PAGE_SIZE);
	settings.totalItems = 0;
	settings.totalPages = 1;	
	settings.sortColumn = firstCol
	settings.sortDirection = firstCol.columnName == 'Year'?'DESC':'ASC';
	settings.xAxisDim = null

	//If seriesDim is a geography column select everything if user has not input
	if(settings.seriesDim && settings.seriesDim.geoLabelFlag && !userInputStatus.geo) {
		let allVal = settings.seriesDim.totalLabel
		settings.seriesDim.appliedValues.forEach(x => {
			if(x.name != allVal)
				x.selected = true
		})
	}
	return settings
}

async function fetchFile(url) {
	try {
		// Make the fetch request and wait for the response
		const response = await fetch(url);

		// Check if the response was successful (status code 200-299)
		if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
		}

		// Parse the response body as JSON and wait for the result
		const data = await response.json();

		// Return the fetched data
		return data;
	} catch (error) {
		// Handle any errors that occurred during the fetch or parsing
		console.error('Error fetching data:', error);
		// Re-throw the error or return a default value/null depending on your needs
		throw error; 
	}
}

//Method called when chart is being rebuilt from URL parameters
async function rebuildMapSettings(indicator, type, objReq) {
	if(import.meta.env.VITE_APP_DEBUG) {
		console.log('rebuildMapSettings')
	}

	let mapProperties = await fetchFile(import.meta.env.VITE_BASE_URL + '/json/map-properties.json')
	//console.log('mapProperties', mapProperties)
	let mapProps = mapProperties.find(p => p.indicator == indicator.indicatorName)

	const tooltips = [] //TODO: IMPLEMENT CODE TO REBUILD TOOLTIPS

	AppliedValues.setupAppliedValues(indicator)
	AppliedValues.applyRequestFilters(indicator, type, objReq.request)	

	let sortCol = indicator.columns.items.find(col => col.categoryLabelFlag)
	return new ChartSettings(sortCol, type, mapProps, tooltips)
}
 	
function validateRequestProps(obj, indicator) {
	return AppliedValues.validateRequestValues(obj, indicator, ChartTypeEnum.MAP.chartName)
}
export {defineMapProps, getMapSettings, updateMapSettings, rebuildMapSettings, validateRequestProps}
